import React, { FC, useContext, useMemo } from 'react';

import { useQuery } from '@apollo/client';
import {
  H3,
  IDropdownItem,
  Select,
  Separator,
  Toggle,
} from '@smartshell/ui-kit';

import { SettingsBlock, SettingsFrame } from 'components';
import { LocalizationContext } from 'localization';
import { GET_TARIFF_FOR_SETTINGS, ITariffsFromSettingsResponse } from 'schemas';
import { ESettingsAliases, SettingsContext } from 'settings';

import s from './FastLogin.module.scss';

export const FastLogin: FC = () => {
  const { t } = useContext(LocalizationContext);
  const {
    state: { settings },
    actions: { setSetting },
  } = useContext(SettingsContext);

  const { data: tariffs } = useQuery<ITariffsFromSettingsResponse>(
    GET_TARIFF_FOR_SETTINGS,
    {
      fetchPolicy: 'no-cache',
    }
  );

  const tariffOptions = useMemo<IDropdownItem[]>(() => {
    if (!tariffs || !tariffs.tariffs.data) return [];

    return tariffs.tariffs.data.map(
      ({ id, title }): IDropdownItem => ({ title, value: id })
    );
  }, [tariffs]);

  return (
    <SettingsBlock title={t('settings.shell.fast_login.title')}>
      <SettingsFrame>
        <Toggle
          onChange={(value: boolean) =>
            setSetting({
              alias:
                ESettingsAliases.SHELL_FAST_LOGIN_AUTOSTART_SESSION_ENABLED,
              value: value ? '1' : '0',
            })
          }
          value={settings.fastLoginAutostartSessionEnabled}
          label={t('settings.shell.fast_login.autorun_enabled')}
          emptyBg
          variant="secondary"
        />
        <Separator />
        <div className={s.tariff}>
          <H3>{t('settings.shell.fast_login.autorun_tariff')}</H3>
          <Select
            name="fastLoginAutostartSessionTariffId"
            options={tariffOptions}
            value={settings.fastLoginAutostartSessionTariffId || null}
            onChange={(value) => {
              if (!value) return;

              return setSetting({
                alias:
                  ESettingsAliases.SHELL_FAST_LOGIN_AUTOSTART_SESSION_TARIFF_ID,
                value: String(value),
              });
            }}
            bordered
            className={s.select}
            placeholder={t('combo.tariff.add')}
            disableClear
            disabled={
              !tariffOptions.length ||
              !settings.fastLoginAutostartSessionEnabled
            }
          />
        </div>
      </SettingsFrame>
    </SettingsBlock>
  );
};
